import { UpOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './AppTable.module.scss';
const { Panel } = Collapse;
const AppTable = ({ content }: any) => {
    const styleclass: string = content.styleclass?.value;
    const [collapsed, setCollapsed] = useState(false);
    const tbl = (
        <>
            <div
                className={styles['table-container']}
                dangerouslySetInnerHTML={{
                    __html: content.tableHtml.value,
                }}
            ></div>
            {content?.tableFooter?.value && (
                <div
                    className={classNames(styles['table-footer'], 'px-3 md:px-0')}
                    dangerouslySetInnerHTML={{
                        __html: content.tableFooter.value,
                    }}
                ></div>
            )}
        </>
    );
    if (styleclass.includes('accordion')) {
        return (
            <div className={styles['container']}>
                <Collapse
                    className={classNames({ panelOpend: !collapsed }, 'table-collapse')}
                    expandIcon={({ isActive }) => <UpOutlined rotate={isActive ? 0 : 180} />}
                    expandIconPosition='end'
                    defaultActiveKey={['0']}
                    ghost
                    onChange={() => setCollapsed(!collapsed)}
                >
                    <Panel
                        header={<span className="'px-3 md:px-0'">{content.tableHeader.value}</span>}
                        key='0'
                    >
                        {tbl}
                    </Panel>
                </Collapse>
                {collapsed && <div className={styles.split}></div>}
            </div>
        );
    }
    return (
        <>
            {content?.tableHeader?.value && (
                <div
                    className={classNames(styles['table-header'], 'px-3 md:px-0')}
                    dangerouslySetInnerHTML={{
                        __html: content.tableHeader.value,
                    }}
                ></div>
            )}
            {tbl}
        </>
    );
};

export default AppTable;
